import "./AiReportPeriodModal.scss";

import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Box } from "@mui/material";

import { closeModal } from "../../../slices/modalSlice";
import { fetchAiReport } from "../../../slices/aiReportSlice";

import { Button } from "../../../common-components/Buttons/Buttons";
import { InputDate } from "../../../common-components/Inputs/Inputs";

const AiReportPeriodModal = () => {
    const dispatch = useDispatch();

    const token = useSelector((state) => state.auth.token);

    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [validationError, setValidationError] = useState("");

    const handleSubmit = async () => {
        if (!dateFrom || !dateTo) {
            setValidationError("Выберите начальную и конечную дату");
            return;
        }

        if (dateFrom > dateTo) {
            setValidationError("Начальная дата не может быть больше конечной");
            return;
        }

        setValidationError("");

        const customDateRange = `${dateFrom}|${dateTo}`;

        try {
            await dispatch(
                fetchAiReport({
                    token,
                    customDateRange
                })
            ).unwrap();

            dispatch(closeModal());
        } catch (error) {
            setValidationError("Ошибка при загрузке отчета");
        }
    };

    return (
        <Box className="ai_report_period_modal">
            <Box className="ai_report_period_modal_title">
                Выберите период
            </Box>

            <Box className="ai_report_period_modal_fields">
                <Box className="ai_report_period_modal_field">
                    <Box className="ai_report_period_modal_label">
                        Дата начала
                    </Box>

                    <InputDate
                        propertyLabel="Дата начала"
                        value={dateFrom}
                        onChange={setDateFrom}
                    />
                </Box>

                <Box className="ai_report_period_modal_field">
                    <Box className="ai_report_period_modal_label">
                        Дата окончания
                    </Box>

                    <InputDate
                        propertyLabel="Дата окончания"
                        value={dateTo}
                        onChange={setDateTo}
                    />
                </Box>
            </Box>

            {!!validationError && (
                <Box className="ai_report_period_modal_error">
                    {validationError}
                </Box>
            )}

            <Box className="ai_report_period_modal_actions">
                <Button
                    title="Анализировать"
                    onClick={handleSubmit}
                    textColor="#ffffff"
                />
            </Box>
        </Box>
    );
};

export default AiReportPeriodModal;